/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createFavoriteListFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeFavoriteList, serializeUpdateItemQuantityRequest, type ErrorResponse, type FavoriteList, type InternalErrorResponse, type UpdateItemQuantityRequest } from '../../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/favorites/{customerNumber-id}/{favoriteListId}/items/{sku}/quantity
 */
export interface QuantityRequestBuilder extends BaseRequestBuilder<QuantityRequestBuilder> {
    /**
     * Sets the quantity on a SKU already on the list, replacing the value rather than adding to it, and returns the whole list back. The SKU is matched without regard to case and must already be on the list — this endpoint will not add it, and a SKU that is absent is a 400, not a 404; the 404 is reserved for the list itself. Quantity must be greater than zero: clear a line with DELETE /api/favorites/{customerNumber}/{favoriteListId}/items/{sku} rather than by setting it to zero.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FavoriteList>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateItemQuantityRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FavoriteList | undefined>;
    /**
     * Sets the quantity on a SKU already on the list, replacing the value rather than adding to it, and returns the whole list back. The SKU is matched without regard to case and must already be on the list — this endpoint will not add it, and a SKU that is absent is a 400, not a 404; the 404 is reserved for the list itself. Quantity must be greater than zero: clear a line with DELETE /api/favorites/{customerNumber}/{favoriteListId}/items/{sku} rather than by setting it to zero.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateItemQuantityRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const QuantityRequestBuilderUriTemplate = "{+baseurl}/api/favorites/{customerNumber%2Did}/{favoriteListId}/items/{sku}/quantity";
/**
 * Metadata for all the requests in the request builder.
 */
export const QuantityRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: QuantityRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFavoriteListFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateItemQuantityRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
